var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78201 7.55786C10.6683 6.79666 11.2391 5.69361 11.2391 4.44893C11.2391 2.1576 9.34114 0.299988 7 0.299988C4.65886 0.299988 2.76086 2.1576 2.76086 4.44893C2.76086 5.69361 3.33174 6.79666 4.21799 7.55786C2.02156 8.57795 0.5 10.762 0.5 13.3H2.19565C2.19565 10.7022 4.34686 8.59787 7 8.59787C9.65425 8.59787 11.8043 10.7022 11.8043 13.3H13.5C13.5 10.762 11.9773 8.57795 9.78201 7.55786ZM4.45652 4.44893C4.45652 3.07368 5.59486 1.95956 7 1.95956C8.404 1.95956 9.54348 3.07368 9.54348 4.44893C9.54348 5.82414 8.404 6.93829 7 6.93829C5.59486 6.93829 4.45652 5.82414 4.45652 4.44893Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.179624474b5544871ed8fa96bb729b7c.svg";
export { ForwardRef as ReactComponent };